import { FC } from 'react';
import styles from './styles/CheckoutErrorPage.scss';

// components
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';

const CheckoutErrorPage: FC<{ error: Error }> = ({ error }) => (
    <div className={styles.wrapper}>
        <Error500Layout error={error} rumTransactionName="checkout/" />
    </div>
);

export default CheckoutErrorPage;
